import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

@Component({
  selector: 'app-initials-avatar',
  standalone: true,
  imports: [],
  templateUrl: './initials-avatar.component.html',
  styleUrl: './initials-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitialsAvatarComponent {
  public firstName: InputSignal<string | undefined> = input.required();

  public lastName: InputSignal<string | undefined> = input.required();

  public fallbackInitial: InputSignal<string> = input("?");

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  public initials: Signal<string> = computed(() => {
    let firstInitial: string = "";
    let lastInitial: string = "";

    if (this.firstName() && typeof this.firstName() === 'string')
      // eslint-disable-next-line @tseslint/no-non-null-assertion
      firstInitial = this.firstName()![ 0 ]!.toUpperCase();


    if (this.lastName() && typeof this.lastName() === 'string')
    // eslint-disable-next-line @tseslint/no-non-null-assertion
      lastInitial = this.lastName()![ 0 ]!.toUpperCase();


    const combinedInitials: string = firstInitial + lastInitial;

    return combinedInitials === "" ? this.fallbackInitial() : combinedInitials;
  });
}
